import { createSlice } from '@reduxjs/toolkit';

const SystemErrorSlice = createSlice({
  name: 'SystemErrorSlice',
  initialState: {
    isLoading: false,
    errorListData: [],
    isError: null,
  },
  reducers: {
    /////// Error list start //////
    requestSystemErrorList: (state) => {
      return { ...state, isLoading: true };
    },
    responseSystemErrorList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        errorListData: action?.payload?.data,
      };
    },
    failureSystemErrorList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },
  },
});

export const {
  failureSystemErrorList,
  requestSystemErrorList,
  responseSystemErrorList,
} = SystemErrorSlice.actions;
export default SystemErrorSlice.reducer;
